<template>
  <section class="section-padding">
    <div class="container">
      <div class="columns is-centered">
        <div class="column is-12">
          <div class="box">
            <div class="is-flex is-justify-content-space-between is-align-items-center mb-3">
              <div>
                <h1 class="title">Configuraciones</h1>
                <p class="subtitle is-6">Activa o desactiva el registro de interacciones.</p>
              </div>
            </div>

            <ConfigurationsForm :configuration="interactionConfiguration" @saved="loadConfigurations" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import ConfigurationsForm from '../components/form.vue';

export default {
  name: 'ConfigurationsPage',
  components: {
    ConfigurationsForm,
  },
  computed: {
    ...mapState({
      configurations: (state) => state.configurations.list,
    }),
    interactionConfiguration() {
      if (Array.isArray(this.configurations)) {
        return this.configurations.find((item) => item.clave === 'interacciones_habilitadas') || {};
      }
      return {};
    },
  },
  async created() {
    await this.loadConfigurations();
  },
  methods: {
    ...mapActions({
      fetchList: 'configurations/fetchList',
    }),
    async loadConfigurations() {
      const params = {
        keys: 'interacciones_habilitadas',
        page: 1,
        size: 1,
      };

      await this.fetchList(params);
    },
  },
};
</script>

<style scoped>
.subtitle {
  margin-top: 4px;
}
</style>
